$(document).ready(function () {
  $(function() {
    function handleFooterDisplay() {
      if ($(window).width() < 768) {
        // Below 768px
        $('.footer-block__heading-dropdown').click(function(){
          $(this).parent().toggleClass("active");
          //$(this).next().slideToggle("fast");
        });
      }
    }

    handleFooterDisplay();
    $(window).on('resize', handleFooterDisplay);
  });


});
